<template>
  <div>
    <hr />

    <DataTable
      :data="atencions"
      :columns="[
        { label: 'Fecha Cita',   field: 'fechaCita',
          format: (v) => getFormattedDate(v, 'DD/MM/YYYY') },
        { label: 'Hora',         field: 'horaDesde' },
        { label: 'Especialidad', field: 'nombreEspecialidad' },
        { label: 'Médico',       field: 'nombreMedico' },
      ]"
      idField="idAtencion"
      mensajeVacio="No hay atenciones registradas."
      :acciones="true"
      :mostrarEditar="false"
      :mostrarVer="false"
      :mostrarEliminar="true"
      :mostrarBotonNuevo="false"
      @refresh="getData"
      @info="row => abrirModalEditar(row.idElemEmpr)"
      @delete="row => deleteAtencion(row.idElemEmpr)"	  
    >
    </DataTable>

    <!-- Modal: Resumen de la atención (solo lectura) -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="ventanaModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <span class="material-icons" style="font-size:24px; color:white">medical_information</span>
            <h5 class="modal-title text-white ms-2" id="ventanaModalLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <div class="row g-3">

              <!-- Id Atención -->
              <div class="col-md-3" v-if="btnEditar">
                <label class="form-label small fw-bold">Id Atención</label>
                <input type="text" class="form-control bg-light" v-model="datoAtencion.idAtencion" disabled />
              </div>
              <div class="col-md-9" v-if="btnEditar"></div>

              <!-- Médico -->
              <div class="col-md-6">
                <label class="form-label small fw-bold">Médico</label>
                <input type="text" class="form-control bg-light" v-model="datoAtencion.nombreMedico" disabled />
              </div>

              <!-- Especialidad -->
              <div class="col-md-6">
                <label class="form-label small fw-bold">Especialidad</label>
                <input type="text" class="form-control bg-light" v-model="datoAtencion.nombreEspecialidad" disabled />
              </div>

              <!-- Motivo -->
              <div class="col-md-12">
                <label class="form-label small fw-bold">Motivo</label>
                <input type="text" class="form-control bg-light" v-model="datoAtencion.motivo" disabled />
              </div>

              <!-- Cuadro -->
              <div class="col-md-12">
                <label class="form-label small fw-bold">Cuadro</label>
                <textarea class="form-control bg-light" rows="3" v-model="datoAtencion.cuadro" disabled></textarea>
              </div>

              <!-- Observación -->
              <div class="col-md-12">
                <label class="form-label small fw-bold">Observación</label>
                <textarea class="form-control bg-light" rows="3" v-model="datoAtencion.observacion" disabled></textarea>
              </div>

              <!-- Fechas de auditoría -->
              <div class="col-md-6">
                <label class="form-label small fw-bold">Fecha de Registro</label>
                <input type="text" class="form-control bg-light" :value="getFormattedDate(datoAtencion.fechaReg)" disabled />
              </div>
              <div class="col-md-6">
                <label class="form-label small fw-bold">Fecha de Actualización</label>
                <input type="text" class="form-control bg-light" :value="getFormattedDate(datoAtencion.fechaAct)" disabled />
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue';
import { decodificarTipoCita } from '@/modules/decode.js';
import dateFormat from '@/modules/dateFormat.js';
import api from '@/services/api';
import * as $ from 'jquery';
window['$'] = $;
window['jQuery'] = $;

export default {
  components: { DataTable },

  props: {
    p_idPersona: { type: String, required: true },
  },

  data() {
    return {
      atencions:   [],
      datoAtencion:{},
      titulo:      '',
      btnEditar:   false,
      modalWindow: true,
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },

    descTipoCita(codigo) {
      return decodificarTipoCita(codigo);
    },

    //  Carga
    async getData() {
      const response = await api.get('/vwatencions/idpersona/' + this.p_idPersona);
      this.atencions = response.data.reverse();
    },

    //  Modal
    abrirModalEditar(idAtencion) {
      this.modalWindow = true;
      if (idAtencion != null) {
        api.get('/vwatencions/' + idAtencion).then(resp => {
          this.datoAtencion = resp.data;
        });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Resumen de la atención';
      this.btnEditar = true;
    },

    //  Eliminar
    async deleteAtencion(idAtencion) {
      try {
        await api.delete('/atencions/' + idAtencion);
        this.getData();
      } catch {
        alert('No se pudo eliminar');
      }
    },
  },
};
</script>

<style src="@/assets/css/listaFiltrada.css" scoped></style>